<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="acknow"></a><a id="pag_ix">ACKNOWLEDGMENTS</a></h2><a id="pag_ix">
<p class="noindent">Once again, my heartfelt thanks go out to all the folks who help turn my words into a book.</p>
<p class="indent">Thanks go to my agent, Annelise Robey, and editors, Adam Wilson and Lauren McKenna, for all their helpful advice, support, and encouragement. Thanks also to Julia Fincher.</p>
<p class="indent">Thanks to Tony Mauro for designing another terrific cover, and thanks to Louise Burke, Lisa Litwack, and everyone else at Pocket Books and Simon &amp; Schuster for their work on the cover, the book, and the series.</p>
<p class="indent">And finally, a big thanks to all the readers. Knowing that folks read and enjoy my books is truly humbling, and I’m glad that you are all enjoying Gin and her adventures.</p>
<p class="indent">I appreciate you all more than you will ever know.</p>
</a><p class="indent"><a id="pag_ix">Happy reading!</a><a id="pag_x"></a><a id="pag_xi"></a><a id="pag_xii"></a></p><a id="pag_xii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknow.vue?53b1767e